/**
 * Home 页与弹窗共用 — 与 forttrade-dapp 新版 UI 色板对齐（青绿主色 + 冷色描边）
 */
export const C = {
  primary: "#22c55e",
  green: "#22c55e",
  red: "#ef4444",
  /** 与 dapp 专业版标签一致（暗金） */
  amber: "#d4a574",
  blue: "#3b82f6",
  cyan: "#2196f6",
  purple: "#a855f7",
  text: "#e0e6f0",
  muted: "#8892a8",
  dim: "#586580",
  bg: "#060810",
  card: "#0c1020",
  card2: "#111628",
  border: "rgba(100,140,200,0.08)",
};
